var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "currentColor",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-124.228a3.974 3.974 0 0 0-3.079 1.438c-11.859 14.498-18.966 33.036-18.966 53.221-.001 46.106 36.774 83.464 82.874 84.152 47.069.702 85.445-37.243 85.445-84.151 0-20.185-7.107-38.723-18.965-53.221A3.98 3.98 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(198.853 269.398)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a34.582 34.582 0 0 0 17.57-9.46c6.26-6.261 10.14-14.921 10.14-24.48v-22.79",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(143.66 326.121)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v22.79c0 16.75 11.9 30.731 27.71 33.94",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(102.11 269.39)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-12.856-10.423-23.279-23.28-23.279-12.857 0-23.28 10.423-23.28 23.279 0 12.857 10.423 23.28 23.28 23.28C-10.423 23.28 0 12.857 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(160.02 348.353)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-51.67",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(268.13 113.45)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v71.19c0 6.63 5.37 12 12 12h472.84c6.63 0 12-5.37 12-12v-357.85c0-6.63-5.37-12-12-12h-33",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(7.58 412.11)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-251.66c0-6.63 5.37-12 12-12h36.37",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(7.58 377.11)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-496.84",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(504.42 436.945)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h262.87",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(50.57 466.125)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.392",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(458.038 466.125)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.392",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(429.647 466.125)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h3.391",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(401.256 466.125)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-118.783a4 4 0 0 0-4 4v33.087a4 4 0 0 0 4 4H0a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(196.13 194.782)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.957a4 4 0 0 0 4 4h93.289a4 4 0 0 0 4-4V0a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(313.13 200.986)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 67.746 50.798c.863.647 2.098.5 2.768-.347 21.9-27.689 26.171-64.48 10.821-94.482a83.205 83.205 0 0 0-13.651-19.298c-.749-.79-2.002-.815-2.801-.074L-.16-3.066A2 2 0 0 0 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(128.704 97.709)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-19.56-23.06-52.1-32.78-82.22-21.92-38.77 13.97-58.87 56.731-44.9 95.5 13.97 38.771 56.73 58.87 95.5 44.9A74.394 74.394 0 0 0 .17 96.351",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(184.14 43.06)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.261",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(313.13 161.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59.645",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(354.775 161.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.261",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(313.13 129.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59.645",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(354.775 129.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.261",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(313.13 97.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59.645",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(354.775 97.394)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-101.844a2 2 0 0 1 2-2h142.82",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(284.826 408.219)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-46.3-33.7",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(331.13 381.34)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-28.591-22.4",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(419.98 377.3)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-20.08 22.25",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(371.38 357.01)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-7.614-6.172-13.786-13.785-13.786S-27.57-7.614-27.57 0c0 7.613 6.172 13.785 13.785 13.785S0 7.613 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(355.962 389.584)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-7.613-6.172-13.785-13.786-13.785-7.613 0-13.785 6.172-13.785 13.785s6.172 13.785 13.785 13.785C-6.172 13.785 0 7.613 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(394.18 346.595)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-7.613-6.172-13.785-13.785-13.785S-27.57-7.613-27.57 0s6.172 13.785 13.785 13.785S0 7.613 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(444.32 386.157)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-95.02c0-4.419-3.58-8-8-8h-42.39a4 4 0 0 0-4 4v19.191c0 2.21-1.79 4-4 4h-74.51c-2.21 0-4-1.79-4-4V-99.02c0-2.209-1.789-4-4-4h-42.39c-4.42 0-8 3.581-8 8v217.21c0 4.42 3.58 8 8 8H-8c4.42 0 8-3.58 8-8V35",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(459.42 139.2)",
    fill: "currentColor",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboardIcon.814a5533496a8c4d19bd3d8e06132e90.svg";
export { ForwardRef as ReactComponent };